export default __webpack_public_path__ + "static/media/023-balloons.926bebb9.svg";